module.exports = __webpack_public_path__ + "img/izvestaji.8445a08a.svg";